import { getDistance } from 'geolib';
import { getCurrentTime, toast } from '../../utils/_helpers';
import { UNLOAD_DOCS } from './firestore';

export const INIT_AUTH = 'INIT_AUTH';
export const INIT_AUTH_LOADING = 'INIT_AUTH_LOADING';
export const INIT_AUTH_LOADED = 'INIT_AUTH_LOADED';
export const INIT_AUTH_ERROR = 'INIT_AUTH_ERROR';

export const PROFILE_LOADED = 'PROFILE_LOADED';
export const PROFILE = 'PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';

export const initAuth = (firebase, f7) => (dispatch) => {
  dispatch({ type: INIT_AUTH_LOADING });
  firebase.auth().onAuthStateChanged(
    (user) => {
      if (user) {
        firebase
          .firestore()
          .collection('users')
          .doc(user.uid)
          .onSnapshot(
            (profile) => {
              if (
                profile.exists &&
                profile.data().accountStatus &&
                profile.data().accountStatus === 'Suspended'
              ) {
                firebase.auth().signOut();
                toast(f7.toast, {
                  text:
                    'Your account has been suspended. Please contact us at admin@easychaw.com',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
                user = null;
                dispatch({ type: INIT_AUTH, payload: user });
                dispatch({ type: INIT_AUTH_LOADED });
              } else {
                dispatch({ type: INIT_AUTH, payload: user });
                dispatch({ type: INIT_AUTH_LOADED });

                // update players collection with onesignal playerID
                if (f7.device.cordova) {
                  if (f7.device.ios || f7.device.android) {
                    getIds();
                    let playerID = localStorage.playerID;
                    // delay call by 10s for sdk to fetch playerID
                    setTimeout(() => {
                      getIds();
                      playerID = localStorage.playerID;
                      firebase
                        .firestore()
                        .collection('players')
                        .doc(user.uid)
                        .set({
                          playerID: playerID,
                        })
                        .then((doc) => {
                          console.log('playerID registered');
                        })
                        .catch((error) => {
                          console.log('playerID registration failed' + error);
                        });
                    }, 10000);
                  }
                }
              }
            },
            (error) => {
              if (error.code === 'unavailable') {
                toast(f7.toast, {
                  text:
                    'Service Unavailable. This may be due to slow or no internet connection.',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }
              dispatch({
                type: PROFILE_ERROR,
                payload: { code: error.code, message: error.message },
              });
              dispatch({ type: PROFILE_LOADED });
            }
          );
      } else {
        dispatch({ type: INIT_AUTH, payload: null });
        dispatch({ type: INIT_AUTH_LOADED });
        dispatch({ type: UNLOAD_DOCS });
      }
    },
    (error) => {
      dispatch({
        type: INIT_AUTH_ERROR,
        payload: { code: error.code, message: error.message },
      });
      dispatch({ type: INIT_AUTH_LOADED });
      dispatch({ type: UNLOAD_DOCS });
    }
  );
};
